<template>
  <sc-rich-text class="c-rich-text" v-if="fields && fields.content" :field="fields.content" />
</template>

<script>
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-RichText',
  components: {
    ScRichText: RichText
  },
  props: {
    fields: {
      type: Object
    }
  }
};
</script>
<style lang="scss">
.rich-text {
  padding: 2rem;

  &-three-column {
    margin: 2rem 0;

    @include desktop-up {
      display: flex;
      flex-direction: row;
      margin: 2rem 0 4rem 0;
    }

    .column {
      margin-bottom: 1rem;

      @include desktop-up {
        width: calc(100% / 3);
        padding: 1rem;
        margin-bottom: 0;
      }

      &:first-child {
        @include desktop-up {
          padding-left: 0;
        }
      }

      &:last-child {
        @include desktop-up {
          padding-right: 0;
        }
      }

      .column-label {
        display: block;
        @include font-styles('Arial', 1.4rem, 600, normal, 1.7rem, 0, $dark-blue);
      }
    }
  }
}

.scroll-down {
  display: inline-block;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    background-image: url(~@/assets/images/icon-scroll-down.svg);
    background-repeat: no-repeat;
    background-size: contain;
    width: 4rem;
    height: 4rem;
    transition: 0.25s;
    right: -5rem;
    top: -0.5rem;
  }
}
</style>
